import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=70d8400b&scoped=true&"
import script from "./plan.js?vue&type=script&lang=js&"
export * from "./plan.js?vue&type=script&lang=js&"
import style0 from "./plan.scss?vue&type=style&index=0&id=70d8400b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8400b",
  null
  
)

export default component.exports